export default class Utils {
  static isConfirmDisabled(selectedBrandRequest, selectedBrandIndex) {
    const selectedBrand = selectedBrandRequest.brands[selectedBrandIndex];

    const geoCountryId = Utils.getGeoCountryId(selectedBrand, selectedBrandRequest);
    const industryId = Utils.getIndustryId(selectedBrand, selectedBrandRequest);

    const logoVersionRequests = selectedBrandRequest.logoVersionRequests.filter(
      lvr => selectedBrand !== undefined && lvr.brandId == selectedBrand.id // eslint-disable-line eqeqeq
    );

    const isConfirmDisabled =
      // Either a brand is not selected
      selectedBrandIndex === undefined ||
      /**
       * OR is a new brand but:
       * no logos uploaded OR
       * no industry selected OR
       * no country selected
       */
      (selectedBrand &&
        !selectedBrand.id &&
        (logoVersionRequests.length === 0 || !industryId || !geoCountryId));

    return isConfirmDisabled;
  }

  static getGeoCountryId(selectedBrand, selectedBrandRequest) {
    const geoCountryId =
      (selectedBrand && !selectedBrand.id && selectedBrandRequest.countryId) ||
      (selectedBrand &&
        selectedBrand.logos.length &&
        selectedBrand.logos[0].geoCountryId);

    return geoCountryId;
  }

  static getIndustryId(selectedBrand, selectedBrandRequest) {
    const industryId =
      (selectedBrand && !selectedBrand.id && selectedBrandRequest.industryId) ||
      (selectedBrand && selectedBrand.id && selectedBrand.industry.id) ||
      0;
    
    return industryId;
  }
}



// WEBPACK FOOTER //
// ./src/Utils.js